import { atomWithStorage } from 'jotai/utils';

import { localesTranslations } from './localesTranslation';

const list_languages = Object.keys(localesTranslations);

export const localeAvailable = (newLocale: string) => {
  return list_languages.includes(newLocale) ? newLocale : 'en';
};

export const _storeLocale = atomWithStorage(
  '_storeLocale',
  localeAvailable(navigator.language.split(/[-_]/)[0]),
);
